{
  "id": "skirmish_01",
  "name": "Skirmish-01",
  "mode": "HOTSEAT_2P",
  "ruleset": "OFFICIAL_SKIRMISH",
  "objective": "Oficiální cíl: soupeř prohrává, když mu nezůstane žádná figurka.",
  "randomStart": true,
  "credits": {"EFA": 20, "REDCAT": 20},
  "terrain": [
    "VMVMVMVHVMVMVMVMVMVMV",
    "MMMMMMMMWMMMWHMMMMMMM",
    "MMMMMMGWWGGGWWGMMMMMM",
    "MMMMMMMWMMMMMWMMMMMMM",
    "MMMMMMWMGMMMMMWMMMMMM",
    "MMMMMWWMMMMMMMWWMGMMM",
    "GMHWMWMMHMMMGMMWMWMMH",
    "WWWMWMMMMMGMMMMMWMWWW",
    "MMGMMMGMMMMMMMHMMGGMM"
  ],
  "ore": [
    [13, 0],
    [7, 1], [9, 1], [10, 1], [11, 1],
    [9, 2], [10, 2], [11, 2],
    [6, 3], [14, 3],
    [5, 4], [15, 4],
    [1, 6], [4, 6], [16, 6], [19, 6],
    [1, 8], [2, 8], [18, 8], [19, 8]
  ],
  "pieces": [
    {"type": "MCV", "owner": "EFA", "col": 0, "row": 1},
    {"type": "MCV", "owner": "REDCAT", "col": 20, "row": 1},
    {"type": "POWER_PLANT", "owner": "GREEN", "col": 7, "row": 7},
    {"type": "POWER_PLANT", "owner": "GREEN", "col": 13, "row": 7}
  ]
}
